/** BioBellinda France — mobile app-shell enhancements; no Shopify cart replacement. */
(() => {
  const badge = document.querySelector('[data-bbf-cart-count]');
  if (!badge) return;
  let nextRun;
  async function updateCartBadge(event) {
    if (event?.detail?.data?.didError) return;
    const eventCount = event?.detail?.data?.itemCount;
    if (Number.isInteger(eventCount) && eventCount >= 0) {
      render(eventCount);
      return;
    }
    clearTimeout(nextRun);
    nextRun = setTimeout(async () => {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin' });
        if (!response.ok) return;
        const cart = await response.json();
        render(cart.item_count || 0);
      } catch (_) { /* Network failure: retain last known count. */ }
    }, 160);
  }
  function render(count) {
    badge.textContent = count > 99 ? '99+' : String(count);
    badge.classList.toggle('is-empty', count === 0);
  }
  document.addEventListener('cart:update', updateCartBadge);
  window.addEventListener('pageshow', event => { if (event.persisted) updateCartBadge(); });
})();
